import { useModuleBEM, useCfarStyles } from "@b2bportal/core-themes";
import { CoreFlightsCfarExerciseComponents } from "@b2bportal/core-types";

import defaultStyles from "./AirCfarExerciseGenericActionView.module.scss";

export interface AirCfarExerciseGenericActionViewProps {
  title: string;
  description: string | JSX.Element;
  headerIcon?: JSX.Element;
  footerButtons?: JSX.Element[];
}

export const AirCfarExerciseGenericActionView = (
  props: AirCfarExerciseGenericActionViewProps
) => {
  const [block, cn] = useModuleBEM(
    useCfarStyles(
      CoreFlightsCfarExerciseComponents.AirCfarExerciseGenericActionView,
      defaultStyles
    ),
    CoreFlightsCfarExerciseComponents.AirCfarExerciseGenericActionView
  );

  const { title, description, footerButtons = [], headerIcon } = props;

  return (
    <div className={block}>
      <div className={cn("header")}>
        {headerIcon ? (
          <div className={cn("header-icon")}>{headerIcon}</div>
        ) : null}
        <div className={cn("title")}>{title}</div>
      </div>
      <div className={cn("body")}>
        <div className={cn("description")}>{description}</div>
      </div>
      <div className={cn("footer")}>
        {footerButtons.map((button, index) => (
          <div key={index} className={cn("action-button")}>
            {button}
          </div>
        ))}
      </div>
    </div>
  );
};
